import { z } from 'zod';

/**
 * Storefront domain types (E-SF02).
 *
 * The needs-quiz (AC3) and the deep-link source (AC1) are the only two pieces of
 * client-derived state the shelf carries. Both are narrow, validated enums — no
 * free text reaches pricing, and the reference usage that drives the shelf
 * headline is always one of the three PUCT EFL reference usages.
 */

/** The three PUCT §25.475 EFL reference usages the price-points endpoint emits. */
export const REFERENCE_USAGES = [500, 1000, 2000] as const;
export type ReferenceUsage = (typeof REFERENCE_USAGES)[number];

/** The default headline usage when there is no quiz answer (standard EFL midpoint). */
export const DEFAULT_REFERENCE_USAGE: ReferenceUsage = 1000;

export const UsageSizeSchema = z.enum(['small', 'medium', 'large']);
export type UsageSize = z.infer<typeof UsageSizeSchema>;

export const HomeTypeSchema = z.enum(['apartment', 'house', 'condo']);
export type HomeType = z.infer<typeof HomeTypeSchema>;

/** AC3 — the two answers the organic-visitor quiz collects. */
export const NeedsQuizResultSchema = z.object({
  usageSize: UsageSizeSchema,
  homeType: HomeTypeSchema,
});
export type NeedsQuizResult = z.infer<typeof NeedsQuizResultSchema>;

/**
 * AC1 — where the visitor came from. `ptc` = Power to Choose deep link (skip the
 * quiz, land straight on the plan). Anything unrecognised is treated as organic.
 */
export const DeepLinkSourceSchema = z.enum(['ptc', 'organic']);
export type DeepLinkSource = z.infer<typeof DeepLinkSourceSchema>;
